import firebase from "./firebase.js";

const firestore = firebase.firestore();

const settings = {};
firestore.settings(settings);

export default firestore;
